// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HostDetails-pageContent-OyXIW {
	max-width: var(--max-content-width);
	position: relative;
	display: block;
	margin: 0px auto;
	padding: 0px;
}

.HostDetails-titleText-Vdyae {
	font-size: 30px;
	margin: 0px;
	color: var(--primary-foreground);
	font-weight: bold;
	word-break: break-word;
}

.HostDetails-titleText-Vdyae:hover,
.HostDetails-titleText-Vdyae:active,
.HostDetails-titleText-Vdyae:focus {
	color: var(--primary-foreground);
	text-decoration: none;
}

.HostDetails-sectionTitleText-SoyZL {
	font-size: 20px;
	margin: 0px;
	margin-bottom: 16px;
	font-weight: 600;
}

.HostDetails-sectionTitleContent-hlrHb {
	font-size: 16px;
	color: var(--secondary-foreground);
}

.HostDetails-sectionCaptionLink-SndKB {
	font-size: 16px;
	color: var(--secondary-foreground);
}

a {
	cursor: pointer;
}

a:focus {
	outline: none;
}

.HostDetails-textMuted-G9Y6P,
.HostDetails-textMuted-G9Y6P:hover,
.HostDetails-textMuted-G9Y6P:focus,
.HostDetails-textMuted-G9Y6P:hover:focus {
	color: var(--secondary-foreground);
	text-decoration: none;
	font-size: inherit;
}

.HostDetails-text-VhJhP {
	color: inherit;
	font-size: inherit;
	font-weight: normal;
}

.HostDetails-textLine-HcLz6 {
	text-decoration: line-through;
}

.HostDetails-textCenter-wIliM {
	text-align: center;
}

.HostDetails-textError-ZZ9cc {
	color: var(--alert-color);
}

.HostDetails-horizontalLineThrough-gAWOn {
	position: relative;
	display: block;
}

.HostDetails-pageContent-OyXIW .HostDetails-horizontalLineThrough-gAWOn:last-child {
	border-bottom: 0px;
}

.HostDetails-space1-V0861 {
	margin-bottom: 6px;
}

.HostDetails-space2-bjO5F {
	margin-bottom: 12px;
}

.HostDetails-space3-m3urw {
	margin-bottom: 18px;
}

.HostDetails-space4-x7HTH {
	margin-bottom: 24px;
}

.HostDetails-space5-xuduM {
	margin-bottom: 48px;
}

.HostDetails-spaceTop1-K32va {
	margin-top: 6px;
}

.HostDetails-spaceTop2-qOHp7 {
	margin-top: 12px;
}

.HostDetails-spaceTop3-zPvaB {
	margin-top: 18px;
}

.HostDetails-spaceTop4-HqbKK {
	margin-top: 24px;
}

.HostDetails-spaceTop5-fh7y6 {
	margin-top: 48px;
}

.HostDetails-padding1-dEDdX {
	padding-bottom: 6px;
}

.HostDetails-padding2-sfU8U {
	padding-bottom: 12px;
}

.HostDetails-padding3-R46UM {
	padding-bottom: 18px;
}

.HostDetails-padding4-SfJ38 {
	padding-bottom: 24px;
}

.HostDetails-padding5-l11e9 {
	padding-bottom: 48px;
}

.HostDetails-paddingTop1-e0zyr {
	padding-top: 6px;
}

.HostDetails-paddingTop2-lF0rw {
	padding-top: 12px;
}

.HostDetails-paddingTop3-Prhjx {
	padding-top: 18px;
}

.HostDetails-paddingTop4-OuZB3 {
	padding-top: 24px;
}

.HostDetails-paddingTop5-hpa6F {
	padding-top: 48px;
}

.HostDetails-noMargin-mFYOO {
	margin: 0px;
}

.HostDetails-noPadding-OawcW {
	padding: 0px;
}

.HostDetails-noBorder-jXoe2 {
	border: 0px none !important;
}

.HostDetails-btn-JttKt {
	padding: 7px 21px;
	border-color: var(--primary-border);
	background: var(--primary-color);
	color: var(--white-color);
	font-weight: bold;
	font-size: 16px;
	outline: none !important;
}

.HostDetails-btnBlock-OTDx7 {
	width: 100%;
	position: relative;
	white-space: normal;
	display: block;
}

.HostDetails-btn-JttKt:hover,
.HostDetails-btn-JttKt:focus,
.HostDetails-btn-JttKt:hover:focus {
	background: transparent;
	color: var(--primary-foreground);
}

.HostDetails-formControlSelect-tPMrB {
	margin-bottom: 8px;
}

.HostDetails-splitList-S9JTg {
	display: inline-block;
	width: 50%;
	font-size: 16px;
	padding-right: 8px;
}

.HostDetails-displayTable-R3Epb {
	display: table;
	width: 100%;
}

.HostDetails-displayTableRow-_pLo3 {
	display: table-row;
	width: 100%;
}

.HostDetails-displayTableCell-AWoCL {
	display: table-cell;
	width: 100%;
}

.HostDetails-displayTableCellIcon-GoWVd {
	display: table-cell;
	vertical-align: top;
}

.HostDetails-textMutedNew-pgJ5n {
	font-size: 16px;
	font-weight: 700;
	vertical-align: middle;
	word-break: break-word;
	line-height: 26px;
}

.HostDetails-tableMarginTop-AbeT9 {
	margin-top: 16px;
}

.HostDetails-calendarTableCell-QZCfQ {
	display: inline-block;
}

.HostDetails-vrAlignTop-zQq5m {
	vertical-align: top;
}

.HostDetails-currenyMarginR-M7vAH {
	margin-right: 6px;
}

.HostDetails-sectionLink-yYgUi {
	border: 1px solid var(--secondary-bg);
	padding: 10px;
	border-radius: 4px;
}

.HostDetails-listingFontSize-T5Lu2 {
	font-size: 16px !important;
}

.HostDetails-vrAlignBottom-UawFl {
	vertical-align: bottom;
}

.HostDetails-introTextPadding-SeHyv {
	padding-left: 8px;
}

.HostDetails-showHideBtn-U_AzG {
	-webkit-box-sizing: border-box !important;
	        box-sizing: border-box !important;
	margin: 0 !important;
	padding: 0px !important;
	width: auto !important;
	outline: 0 !important;
	background: transparent;
	color: var(--primary-link-foreground) !important;
	font-weight: inherit;
	word-wrap: break-word;
	line-height: 18px;
	letter-spacing: normal;
	font-size: 16px !important;
	border: 0px !important;
	text-decoration: underline;
}

.HostDetails-showHideBtn-U_AzG.HostDetails-focus-TMmQx,
.HostDetails-showHideBtn-U_AzG:focus,
.HostDetails-showHideBtn-U_AzG:active,
.HostDetails-showHideBtn-U_AzG:active:focus,
.HostDetails-showHideBtn-U_AzG:focus,
.HostDetails-showHideBtn-U_AzG:hover {
	-webkit-box-sizing: border-box !important;
	        box-sizing: border-box !important;
	margin: 0 !important;
	padding: 0px !important;
	width: auto !important;
	outline: 0 !important;
	background: transparent !important;
	color: var(--primary-link-foreground) !important;
	font-weight: inherit;
	word-wrap: break-word;
	line-height: 18px;
	letter-spacing: normal;
	font-size: 16px;
	border: 0px !important;
}

.HostDetails-showHideMargin-KrAL_ {
	margin-bottom: 10px !important;
}

.HostDetails-listingIntroWidth-vPOhY {
	width: 65%;
}

.HostDetails-showHidePadding-pq9I6 {
	padding-bottom: 10px !important;
}

.HostDetails-vtrTop-YqB4_ {
	vertical-align: top;
}

.HostDetails-listingLine-ueeZQ {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.HostDetails-listingLineTwo-kA8hQ {
	margin: 15px 0 30px;
}

@media screen and (max-width: 767px) {
	.HostDetails-titleText-Vdyae {
		font-weight: 700;
		font-size: 26px;
		word-break: break-word;
	}

	.HostDetails-splitList-S9JTg {
		display: inline-block;
		width: 100% !important;
	}

	.HostDetails-listingIntroWidth-vPOhY {
		width: 100% !important;
	}

	.HostDetails-responsiveListIngIntro-rpiAg {
		display: inline-block !important;
	}
}

.HostDetails-profileAvatarSection-Q70gR {
	position: relative;
	text-align: center;
	margin: 0 auto;
}

.HostDetails-profileAvatarLink-HIIsr {
	-webkit-backface-visibility: hidden;
	        backface-visibility: hidden;
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	overflow: hidden;
	border-radius: 50%;
	background-color: var(--secondary-gray-bg);
	border: 2px solid var(--primary-border);
}

.HostDetails-profileAvatar-RoixH {
	height: 70px;
	width: 70px;
}

.HostDetails-reviewStar-Avo4y {
	display: inline;
	position: relative;
	float: left;
}

.HostDetails-introPadding-jbHWs {
	padding-bottom: 15px;
}

.HostDetails-hostNameText-ffusb {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	max-width: 150px;
	margin: 0 auto;
}

.HostDetails-personalHomeIcon-OOLzL {
	position: relative;
	top: 2px;
}

.HostDetails-flex-utmGl {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	margin-top: 16px;
	font-size: 18px;
}

.HostDetails-locationCss-I6BKG {
	padding-left: 15px;
	position: relative;
}

.HostDetails-titleText-Vdyae {
	font-size: 32px !important;
	color: var(--secondary-oscuro);
	font-family: var(--font-family-primary) !important;
	font-weight: bold;
	margin-bottom: 10px;
}

.HostDetails-locationCss-I6BKG::before {
	content: '';
	width: 5px;
	height: 5px;
	background-color: var(--primary-foreground);
	border-radius: 50%;
	position: absolute;
	top: 50%;
	-webkit-transform: translateY(-50%);
	    -ms-transform: translateY(-50%);
	        transform: translateY(-50%);
	left: 5px;
}

.HostDetails-paddingCss-fwMCs {
	padding: 30px 0px 30px;
}

.HostDetails-saveButtonPosition-Ut3wl {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: end;
	    -ms-flex-pack: end;
	        justify-content: flex-end;
	font-size: 18px;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	/* padding-top: 44px; */
	gap: 30px;
	grid-gap: 30px;
}

.HostDetails-imgCss-jt9JN {
	position: relative;
	top: -2px;
}

.HostDetails-buttonContainer-IRZom {
	cursor: pointer;
	text-align: center;
	cursor: pointer;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-column-gap: 4px;
	   -moz-column-gap: 4px;
	        column-gap: 4px;
	font-size: 18px;
}

.HostDetails-countGap-EoxTn {
	padding-left: 5px;
}

.HostDetails-hostFlex-NfG6j {
	display: grid;
	grid-template-columns: 2fr 1fr;
	gap: 12px;
	grid-gap: 12px;
}

.HostDetails-starRatingIconContainer-qahd3 {
	width: 18px;
	height: 18px;
	position: relative;
	top: -2px;
}

.HostDetails-flex-utmGl {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 10px;
}

.HostDetails-lupaCharacter-ZCBTq {
    width: 89px;
    height: 59px;
    -ms-flex-negative: 0;
        flex-shrink: 0;
}

@media screen and (max-width: 1200px) {
	.HostDetails-paddingCss-fwMCs {
		padding: 30px 0px 30px 0px;
	}
}

@media screen and (max-width: 640px) {
	.HostDetails-introCenter-FInUW {
		text-align: center;
	}

	.HostDetails-bookItPanel-ipMHW {
		text-align: left;
	}
}

@media screen and (max-width: 767px) {
	.HostDetails-profileAvatar-RoixH {
		height: 54px;
		width: 54px;
	}

	.HostDetails-profileAvatarNew-ES1lx {
		height: 100px;
		width: 100px;
	}

	.HostDetails-saveButtonPosition-Ut3wl {
		padding-top: 0px;
		-webkit-box-pack: start;
		    -ms-flex-pack: start;
		        justify-content: flex-start;
	}

	.HostDetails-paddingCss-fwMCs {
		padding: 30px 0px 8px;
	}

	.HostDetails-hostFlex-NfG6j {
		grid-template-columns: 100%;
	}

	.HostDetails-flex-utmGl {
		margin-top: 10px;
	}

	.HostDetails-mobilePaddingRemove-I6xz1 {
		padding-left: 0;
		padding-top: 5px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/ViewListing/common.css","webpack://./src/components/ViewListing/HostDetails/HostDetails.css"],"names":[],"mappings":"AAAA;CACC,mCAAmC;CACnC,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,eAAe;CACf,WAAW;CACX,gCAAgC;CAChC,iBAAiB;CACjB,sBAAsB;AACvB;;AAEA;;;CAGC,gCAAgC;CAChC,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,WAAW;CACX,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,aAAa;AACd;;AAEA;;;;CAIC,kCAAkC;CAClC,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,iBAAiB;CACjB,mCAAmC;CACnC,gCAAgC;CAChC,yBAAyB;CACzB,iBAAiB;CACjB,eAAe;CACf,wBAAwB;AACzB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,mBAAmB;CACnB,cAAc;AACf;;AAEA;;;CAGC,uBAAuB;CACvB,gCAAgC;AACjC;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,sBAAsB;CACtB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,qCAAqC;CACrC,aAAa;CACb,kBAAkB;AACnB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,yCAAiC;SAAjC,iCAAiC;CACjC,oBAAoB;CACpB,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,uBAAuB;CACvB,gDAAgD;CAChD,oBAAoB;CACpB,qBAAqB;CACrB,iBAAiB;CACjB,sBAAsB;CACtB,0BAA0B;CAC1B,sBAAsB;CACtB,0BAA0B;AAC3B;;AAEA;;;;;;CAMC,yCAAiC;SAAjC,iCAAiC;CACjC,oBAAoB;CACpB,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,kCAAkC;CAClC,gDAAgD;CAChD,oBAAoB;CACpB,qBAAqB;CACrB,iBAAiB;CACjB,sBAAsB;CACtB,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC;EACC,gBAAgB;EAChB,eAAe;EACf,sBAAsB;CACvB;;CAEA;EACC,qBAAqB;EACrB,sBAAsB;CACvB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,gCAAgC;CACjC;AACD;;ACjWA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,mCAA2B;SAA3B,2BAA2B;CAC3B,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,gBAAgB;CAChB,kBAAkB;CAClB,0CAA0C;CAC1C,uCAAuC;AACxC;;AAEA;CACC,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,gBAAgB;CAChB,uBAAuB;CACvB,mBAAmB;CACnB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,QAAQ;AACT;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,0BAA0B;CAC1B,8BAA8B;CAC9B,kDAAkD;CAClD,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,UAAU;CACV,WAAW;CACX,2CAA2C;CAC3C,kBAAkB;CAClB,kBAAkB;CAClB,QAAQ;CACR,mCAA2B;KAA3B,+BAA2B;SAA3B,2BAA2B;CAC3B,SAAS;AACV;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,qBAAyB;KAAzB,kBAAyB;SAAzB,yBAAyB;CACzB,eAAe;CACf,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,uBAAuB;CACvB,SAAS;CACT,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,SAAS;AACV;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,uBAAe;IAAf,oBAAe;SAAf,eAAe;CACf,eAAe;AAChB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,SAAS;CACT,cAAc;AACf;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,SAAS;AACV;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAc;QAAd,cAAc;AAClB;;AAEA;CACC;EACC,0BAA0B;CAC3B;AACD;;AAEA;CACC;EACC,kBAAkB;CACnB;;CAEA;EACC,gBAAgB;CACjB;AACD;;AAEA;CACC;EACC,YAAY;EACZ,WAAW;CACZ;;CAEA;EACC,aAAa;EACb,YAAY;CACb;;CAEA;EACC,gBAAgB;EAChB,uBAA2B;MAA3B,oBAA2B;UAA3B,2BAA2B;CAC5B;;CAEA;EACC,qBAAqB;CACtB;;CAEA;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,eAAe;EACf,gBAAgB;CACjB;AACD","sourcesContent":[".pageContent {\n\tmax-width: var(--max-content-width);\n\tposition: relative;\n\tdisplay: block;\n\tmargin: 0px auto;\n\tpadding: 0px;\n}\n\n.titleText {\n\tfont-size: 30px;\n\tmargin: 0px;\n\tcolor: var(--primary-foreground);\n\tfont-weight: bold;\n\tword-break: break-word;\n}\n\n.titleText:hover,\n.titleText:active,\n.titleText:focus {\n\tcolor: var(--primary-foreground);\n\ttext-decoration: none;\n}\n\n.sectionTitleText {\n\tfont-size: 20px;\n\tmargin: 0px;\n\tmargin-bottom: 16px;\n\tfont-weight: 600;\n}\n\n.sectionTitleContent {\n\tfont-size: 16px;\n\tcolor: var(--secondary-foreground);\n}\n\n.sectionCaptionLink {\n\tfont-size: 16px;\n\tcolor: var(--secondary-foreground);\n}\n\na {\n\tcursor: pointer;\n}\n\na:focus {\n\toutline: none;\n}\n\n.textMuted,\n.textMuted:hover,\n.textMuted:focus,\n.textMuted:hover:focus {\n\tcolor: var(--secondary-foreground);\n\ttext-decoration: none;\n\tfont-size: inherit;\n}\n\n.text {\n\tcolor: inherit;\n\tfont-size: inherit;\n\tfont-weight: normal;\n}\n\n.textLine {\n\ttext-decoration: line-through;\n}\n\n.textCenter {\n\ttext-align: center;\n}\n\n.textError {\n\tcolor: var(--alert-color);\n}\n\n.horizontalLineThrough {\n\tposition: relative;\n\tdisplay: block;\n}\n\n.pageContent .horizontalLineThrough:last-child {\n\tborder-bottom: 0px;\n}\n\n.space1 {\n\tmargin-bottom: 6px;\n}\n\n.space2 {\n\tmargin-bottom: 12px;\n}\n\n.space3 {\n\tmargin-bottom: 18px;\n}\n\n.space4 {\n\tmargin-bottom: 24px;\n}\n\n.space5 {\n\tmargin-bottom: 48px;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px;\n}\n\n.spaceTop5 {\n\tmargin-top: 48px;\n}\n\n.padding1 {\n\tpadding-bottom: 6px;\n}\n\n.padding2 {\n\tpadding-bottom: 12px;\n}\n\n.padding3 {\n\tpadding-bottom: 18px;\n}\n\n.padding4 {\n\tpadding-bottom: 24px;\n}\n\n.padding5 {\n\tpadding-bottom: 48px;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px;\n}\n\n.paddingTop5 {\n\tpadding-top: 48px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\n.noPadding {\n\tpadding: 0px;\n}\n\n.noBorder {\n\tborder: 0px none !important;\n}\n\n.btn {\n\tpadding: 7px 21px;\n\tborder-color: var(--primary-border);\n\tbackground: var(--primary-color);\n\tcolor: var(--white-color);\n\tfont-weight: bold;\n\tfont-size: 16px;\n\toutline: none !important;\n}\n\n.btnBlock {\n\twidth: 100%;\n\tposition: relative;\n\twhite-space: normal;\n\tdisplay: block;\n}\n\n.btn:hover,\n.btn:focus,\n.btn:hover:focus {\n\tbackground: transparent;\n\tcolor: var(--primary-foreground);\n}\n\n.formControlSelect {\n\tmargin-bottom: 8px;\n}\n\n.splitList {\n\tdisplay: inline-block;\n\twidth: 50%;\n\tfont-size: 16px;\n\tpadding-right: 8px;\n}\n\n.displayTable {\n\tdisplay: table;\n\twidth: 100%;\n}\n\n.displayTableRow {\n\tdisplay: table-row;\n\twidth: 100%;\n}\n\n.displayTableCell {\n\tdisplay: table-cell;\n\twidth: 100%;\n}\n\n.displayTableCellIcon {\n\tdisplay: table-cell;\n\tvertical-align: top;\n}\n\n.textMutedNew {\n\tfont-size: 16px;\n\tfont-weight: 700;\n\tvertical-align: middle;\n\tword-break: break-word;\n\tline-height: 26px;\n}\n\n.tableMarginTop {\n\tmargin-top: 16px;\n}\n\n.calendarTableCell {\n\tdisplay: inline-block;\n}\n\n.vrAlignTop {\n\tvertical-align: top;\n}\n\n.currenyMarginR {\n\tmargin-right: 6px;\n}\n\n.sectionLink {\n\tborder: 1px solid var(--secondary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n}\n\n.listingFontSize {\n\tfont-size: 16px !important;\n}\n\n.vrAlignBottom {\n\tvertical-align: bottom;\n}\n\n.introTextPadding {\n\tpadding-left: 8px;\n}\n\n.showHideBtn {\n\tbox-sizing: border-box !important;\n\tmargin: 0 !important;\n\tpadding: 0px !important;\n\twidth: auto !important;\n\toutline: 0 !important;\n\tbackground: transparent;\n\tcolor: var(--primary-link-foreground) !important;\n\tfont-weight: inherit;\n\tword-wrap: break-word;\n\tline-height: 18px;\n\tletter-spacing: normal;\n\tfont-size: 16px !important;\n\tborder: 0px !important;\n\ttext-decoration: underline;\n}\n\n.showHideBtn.focus,\n.showHideBtn:focus,\n.showHideBtn:active,\n.showHideBtn:active:focus,\n.showHideBtn:focus,\n.showHideBtn:hover {\n\tbox-sizing: border-box !important;\n\tmargin: 0 !important;\n\tpadding: 0px !important;\n\twidth: auto !important;\n\toutline: 0 !important;\n\tbackground: transparent !important;\n\tcolor: var(--primary-link-foreground) !important;\n\tfont-weight: inherit;\n\tword-wrap: break-word;\n\tline-height: 18px;\n\tletter-spacing: normal;\n\tfont-size: 16px;\n\tborder: 0px !important;\n}\n\n.showHideMargin {\n\tmargin-bottom: 10px !important;\n}\n\n.listingIntroWidth {\n\twidth: 65%;\n}\n\n.showHidePadding {\n\tpadding-bottom: 10px !important;\n}\n\n.vtrTop {\n\tvertical-align: top;\n}\n\n.listingLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.listingLineTwo {\n\tmargin: 15px 0 30px;\n}\n\n@media screen and (max-width: 767px) {\n\t.titleText {\n\t\tfont-weight: 700;\n\t\tfont-size: 26px;\n\t\tword-break: break-word;\n\t}\n\n\t.splitList {\n\t\tdisplay: inline-block;\n\t\twidth: 100% !important;\n\t}\n\n\t.listingIntroWidth {\n\t\twidth: 100% !important;\n\t}\n\n\t.responsiveListIngIntro {\n\t\tdisplay: inline-block !important;\n\t}\n}","@import '../common.css';\n\n.profileAvatarSection {\n\tposition: relative;\n\ttext-align: center;\n\tmargin: 0 auto;\n}\n\n.profileAvatarLink {\n\tbackface-visibility: hidden;\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\toverflow: hidden;\n\tborder-radius: 50%;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 2px solid var(--primary-border);\n}\n\n.profileAvatar {\n\theight: 70px;\n\twidth: 70px;\n}\n\n.reviewStar {\n\tdisplay: inline;\n\tposition: relative;\n\tfloat: left;\n}\n\n.introPadding {\n\tpadding-bottom: 15px;\n}\n\n.hostNameText {\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n\tmax-width: 150px;\n\tmargin: 0 auto;\n}\n\n.personalHomeIcon {\n\tposition: relative;\n\ttop: 2px;\n}\n\n.flex {\n\tdisplay: flex;\n\tmargin-top: 16px;\n\tfont-size: 18px;\n}\n\n.locationCss {\n\tpadding-left: 15px;\n\tposition: relative;\n}\n\n.titleText {\n\tfont-size: 32px !important;\n\tcolor: var(--secondary-oscuro);\n\tfont-family: var(--font-family-primary) !important;\n\tfont-weight: bold;\n\tmargin-bottom: 10px;\n}\n\n.locationCss::before {\n\tcontent: '';\n\twidth: 5px;\n\theight: 5px;\n\tbackground-color: var(--primary-foreground);\n\tborder-radius: 50%;\n\tposition: absolute;\n\ttop: 50%;\n\ttransform: translateY(-50%);\n\tleft: 5px;\n}\n\n.paddingCss {\n\tpadding: 30px 0px 30px;\n}\n\n.saveButtonPosition {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tfont-size: 18px;\n\talign-items: center;\n\t/* padding-top: 44px; */\n\tgap: 30px;\n\tgrid-gap: 30px;\n}\n\n.imgCss {\n\tposition: relative;\n\ttop: -2px;\n}\n\n.buttonContainer {\n\tcursor: pointer;\n\ttext-align: center;\n\tcursor: pointer;\n\tdisplay: flex;\n\tcolumn-gap: 4px;\n\tfont-size: 18px;\n}\n\n.countGap {\n\tpadding-left: 5px;\n}\n\n.hostFlex {\n\tdisplay: grid;\n\tgrid-template-columns: 2fr 1fr;\n\tgap: 12px;\n\tgrid-gap: 12px;\n}\n\n.starRatingIconContainer {\n\twidth: 18px;\n\theight: 18px;\n\tposition: relative;\n\ttop: -2px;\n}\n\n.flex {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 10px;\n}\n\n.lupaCharacter {\n    width: 89px;\n    height: 59px;\n    flex-shrink: 0;\n}\n\n@media screen and (max-width: 1200px) {\n\t.paddingCss {\n\t\tpadding: 30px 0px 30px 0px;\n\t}\n}\n\n@media screen and (max-width: 640px) {\n\t.introCenter {\n\t\ttext-align: center;\n\t}\n\n\t.bookItPanel {\n\t\ttext-align: left;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.profileAvatar {\n\t\theight: 54px;\n\t\twidth: 54px;\n\t}\n\n\t.profileAvatarNew {\n\t\theight: 100px;\n\t\twidth: 100px;\n\t}\n\n\t.saveButtonPosition {\n\t\tpadding-top: 0px;\n\t\tjustify-content: flex-start;\n\t}\n\n\t.paddingCss {\n\t\tpadding: 30px 0px 8px;\n\t}\n\n\t.hostFlex {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.flex {\n\t\tmargin-top: 10px;\n\t}\n\n\t.mobilePaddingRemove {\n\t\tpadding-left: 0;\n\t\tpadding-top: 5px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageContent": `HostDetails-pageContent-OyXIW`,
	"titleText": `HostDetails-titleText-Vdyae`,
	"sectionTitleText": `HostDetails-sectionTitleText-SoyZL`,
	"sectionTitleContent": `HostDetails-sectionTitleContent-hlrHb`,
	"sectionCaptionLink": `HostDetails-sectionCaptionLink-SndKB`,
	"textMuted": `HostDetails-textMuted-G9Y6P`,
	"text": `HostDetails-text-VhJhP`,
	"textLine": `HostDetails-textLine-HcLz6`,
	"textCenter": `HostDetails-textCenter-wIliM`,
	"textError": `HostDetails-textError-ZZ9cc`,
	"horizontalLineThrough": `HostDetails-horizontalLineThrough-gAWOn`,
	"space1": `HostDetails-space1-V0861`,
	"space2": `HostDetails-space2-bjO5F`,
	"space3": `HostDetails-space3-m3urw`,
	"space4": `HostDetails-space4-x7HTH`,
	"space5": `HostDetails-space5-xuduM`,
	"spaceTop1": `HostDetails-spaceTop1-K32va`,
	"spaceTop2": `HostDetails-spaceTop2-qOHp7`,
	"spaceTop3": `HostDetails-spaceTop3-zPvaB`,
	"spaceTop4": `HostDetails-spaceTop4-HqbKK`,
	"spaceTop5": `HostDetails-spaceTop5-fh7y6`,
	"padding1": `HostDetails-padding1-dEDdX`,
	"padding2": `HostDetails-padding2-sfU8U`,
	"padding3": `HostDetails-padding3-R46UM`,
	"padding4": `HostDetails-padding4-SfJ38`,
	"padding5": `HostDetails-padding5-l11e9`,
	"paddingTop1": `HostDetails-paddingTop1-e0zyr`,
	"paddingTop2": `HostDetails-paddingTop2-lF0rw`,
	"paddingTop3": `HostDetails-paddingTop3-Prhjx`,
	"paddingTop4": `HostDetails-paddingTop4-OuZB3`,
	"paddingTop5": `HostDetails-paddingTop5-hpa6F`,
	"noMargin": `HostDetails-noMargin-mFYOO`,
	"noPadding": `HostDetails-noPadding-OawcW`,
	"noBorder": `HostDetails-noBorder-jXoe2`,
	"btn": `HostDetails-btn-JttKt`,
	"btnBlock": `HostDetails-btnBlock-OTDx7`,
	"formControlSelect": `HostDetails-formControlSelect-tPMrB`,
	"splitList": `HostDetails-splitList-S9JTg`,
	"displayTable": `HostDetails-displayTable-R3Epb`,
	"displayTableRow": `HostDetails-displayTableRow-_pLo3`,
	"displayTableCell": `HostDetails-displayTableCell-AWoCL`,
	"displayTableCellIcon": `HostDetails-displayTableCellIcon-GoWVd`,
	"textMutedNew": `HostDetails-textMutedNew-pgJ5n`,
	"tableMarginTop": `HostDetails-tableMarginTop-AbeT9`,
	"calendarTableCell": `HostDetails-calendarTableCell-QZCfQ`,
	"vrAlignTop": `HostDetails-vrAlignTop-zQq5m`,
	"currenyMarginR": `HostDetails-currenyMarginR-M7vAH`,
	"sectionLink": `HostDetails-sectionLink-yYgUi`,
	"listingFontSize": `HostDetails-listingFontSize-T5Lu2`,
	"vrAlignBottom": `HostDetails-vrAlignBottom-UawFl`,
	"introTextPadding": `HostDetails-introTextPadding-SeHyv`,
	"showHideBtn": `HostDetails-showHideBtn-U_AzG`,
	"focus": `HostDetails-focus-TMmQx`,
	"showHideMargin": `HostDetails-showHideMargin-KrAL_`,
	"listingIntroWidth": `HostDetails-listingIntroWidth-vPOhY`,
	"showHidePadding": `HostDetails-showHidePadding-pq9I6`,
	"vtrTop": `HostDetails-vtrTop-YqB4_`,
	"listingLine": `HostDetails-listingLine-ueeZQ`,
	"listingLineTwo": `HostDetails-listingLineTwo-kA8hQ`,
	"responsiveListIngIntro": `HostDetails-responsiveListIngIntro-rpiAg`,
	"profileAvatarSection": `HostDetails-profileAvatarSection-Q70gR`,
	"profileAvatarLink": `HostDetails-profileAvatarLink-HIIsr`,
	"profileAvatar": `HostDetails-profileAvatar-RoixH`,
	"reviewStar": `HostDetails-reviewStar-Avo4y`,
	"introPadding": `HostDetails-introPadding-jbHWs`,
	"hostNameText": `HostDetails-hostNameText-ffusb`,
	"personalHomeIcon": `HostDetails-personalHomeIcon-OOLzL`,
	"flex": `HostDetails-flex-utmGl`,
	"locationCss": `HostDetails-locationCss-I6BKG`,
	"paddingCss": `HostDetails-paddingCss-fwMCs`,
	"saveButtonPosition": `HostDetails-saveButtonPosition-Ut3wl`,
	"imgCss": `HostDetails-imgCss-jt9JN`,
	"buttonContainer": `HostDetails-buttonContainer-IRZom`,
	"countGap": `HostDetails-countGap-EoxTn`,
	"hostFlex": `HostDetails-hostFlex-NfG6j`,
	"starRatingIconContainer": `HostDetails-starRatingIconContainer-qahd3`,
	"lupaCharacter": `HostDetails-lupaCharacter-ZCBTq`,
	"introCenter": `HostDetails-introCenter-FInUW`,
	"bookItPanel": `HostDetails-bookItPanel-ipMHW`,
	"profileAvatarNew": `HostDetails-profileAvatarNew-ES1lx`,
	"mobilePaddingRemove": `HostDetails-mobilePaddingRemove-I6xz1`
};
module.exports = ___CSS_LOADER_EXPORT___;
